export function formatAsMoney(value, country, currency) {
    return new Intl.NumberFormat(`en-${country}`, {
        style: 'currency',
        currency,
        currencyDisplay: 'narrowSymbol'
      }).format(value) + ' ' + currency;
}
